import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {FITHGameMode} from "../../gameMode/FITHGameMode";
import {FITHGameModuleConfig} from "../../FITHGameModuleConfig";
import {FITHGameConfig} from "../../FITHGameConfig";

export class FITHReels extends Reels {
    private _mode: string = "";
    set mode(value: string) {
        this._mode = value;
    }

    public trainStopped(): void {
        this.onStopSpin({
            quickStop: false,
            fastSpin: false
        });
    }

    protected onStopSpin(stopData: { quickStop: boolean; fastSpin: boolean }): void {
        if (this._mode === FITHGameMode.BONUS) {
            // handled from FITHBonusGameSpinView.ts
            return;
        }
        super.onStopSpin(stopData);
    }

    protected onReelSpinStarted(reelId: number): void {
        if (reelId === 0 && this._mode === FITHGameMode.BONUS) {
            const lastReelIdx: number = (FITHGameConfig.instance.REELS_NUM - 1);
            this._reelsSpinStates = [...FITHGameModuleConfig.spinController.getReelsToSpinBonusGame()];
            this._reelsActualSpinningStates = [...FITHGameModuleConfig.spinController.getReelsToSpinBonusGame()];

            this._reelsSpinStates[lastReelIdx] = true;
            this._reelsActualSpinningStates[lastReelIdx] = true;
        }
        super.onReelSpinStarted(reelId);
    }
}